export const lifeKoshaInfo = {
  annamaya: {
    name: "Annamaya Kosha",
    subtitle: "Physical Layer",
    description: "Your physical well-being - body health, nutrition, rest, and material security.",
    color: "#8B4513",
    icon: "🌍"
  },
  pranamaya: {
    name: "Pranamaya Kosha",
    subtitle: "Energy Layer",
    description: "Your vital energy and life force - breath, vitality, and daily enthusiasm.",
    color: "#FF6B35",
    icon: "⚡"
  },
  manomaya: {
    name: "Manomaya Kosha",
    subtitle: "Mind Layer",
    description: "Your mental and emotional state - thoughts, feelings, and psychological balance.",
    color: "#1E3A5F",
    icon: "🧠"
  },
  vijnanamaya: {
    name: "Vijnanamaya Kosha",
    subtitle: "Wisdom Layer",
    description: "Your intellectual growth and wisdom - learning, discernment, and life direction.",
    color: "#6B21A8",
    icon: "💡"
  },
  anandamaya: {
    name: "Anandamaya Kosha",
    subtitle: "Bliss Layer",
    description: "Your spiritual fulfillment and inner peace - joy, purpose, and connection to the divine.",
    color: "#D4A853",
    icon: "✨"
  }
};

export const lifeQuestions = [
  // Annamaya Kosha - Physical Layer (5 questions)
  {
    id: 1,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How would you rate your overall physical health and energy levels?",
    options: [
      { value: 1, label: "Very poor - Constant fatigue" },
      { value: 2, label: "Below average" },
      { value: 3, label: "Average - Some good days" },
      { value: 4, label: "Good - Mostly energetic" },
      { value: 5, label: "Excellent - Vibrant health" }
    ]
  },
  {
    id: 2,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How satisfied are you with your sleep quality and rest patterns?",
    options: [
      { value: 1, label: "Very dissatisfied - Chronic issues" },
      { value: 2, label: "Dissatisfied" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Satisfied" },
      { value: 5, label: "Very satisfied - Deep, restorative sleep" }
    ]
  },
  {
    id: 3,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How regularly do you engage in physical exercise or movement practices?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely - Once a month" },
      { value: 3, label: "Sometimes - Weekly" },
      { value: 4, label: "Often - Several times a week" },
      { value: 5, label: "Daily - It's part of my lifestyle" }
    ]
  },
  {
    id: 4,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How mindful are you about your nutrition and eating habits?",
    options: [
      { value: 1, label: "Not at all - I eat whatever" },
      { value: 2, label: "Slightly aware" },
      { value: 3, label: "Moderately mindful" },
      { value: 4, label: "Very mindful" },
      { value: 5, label: "Extremely conscious - Sattvic diet" }
    ]
  },
  {
    id: 5,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How secure do you feel about your material needs (shelter, finances, basic needs)?",
    options: [
      { value: 1, label: "Very insecure - Constant worry" },
      { value: 2, label: "Insecure" },
      { value: 3, label: "Somewhat secure" },
      { value: 4, label: "Secure" },
      { value: 5, label: "Completely secure - Abundant" }
    ]
  },
  // Pranamaya Kosha - Energy Layer (5 questions)
  {
    id: 6,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "How would you describe your overall life energy and vitality?",
    options: [
      { value: 1, label: "Depleted - Running on empty" },
      { value: 2, label: "Low energy" },
      { value: 3, label: "Moderate" },
      { value: 4, label: "High energy" },
      { value: 5, label: "Vibrant - Overflowing vitality" }
    ]
  },
  {
    id: 7,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "Do you practice any breathwork, pranayama, or conscious breathing?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Occasionally" },
      { value: 4, label: "Regularly" },
      { value: 5, label: "Daily - Essential practice" }
    ]
  },
  {
    id: 8,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "How well do you manage your energy throughout the day?",
    options: [
      { value: 1, label: "Poorly - Crash by afternoon" },
      { value: 2, label: "Struggle often" },
      { value: 3, label: "Moderate" },
      { value: 4, label: "Well - Steady energy" },
      { value: 5, label: "Excellent - Optimal all day" }
    ]
  },
  {
    id: 9,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "How connected do you feel to nature and natural rhythms?",
    options: [
      { value: 1, label: "Disconnected" },
      { value: 2, label: "Rarely connected" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often connected" },
      { value: 5, label: "Deeply attuned" }
    ]
  },
  {
    id: 10,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "Do you feel enthusiastic about starting each new day?",
    options: [
      { value: 1, label: "Never - Dread mornings" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always - Excited to wake up" }
    ]
  },
  // Manomaya Kosha - Mind Layer (5 questions)
  {
    id: 11,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How would you describe your general mental state?",
    options: [
      { value: 1, label: "Anxious/Depressed" },
      { value: 2, label: "Often stressed" },
      { value: 3, label: "Mixed - ups and downs" },
      { value: 4, label: "Generally peaceful" },
      { value: 5, label: "Calm and centered" }
    ]
  },
  {
    id: 12,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How well do you manage negative emotions like anger, fear, or jealousy?",
    options: [
      { value: 1, label: "Poorly - They control me" },
      { value: 2, label: "Struggle significantly" },
      { value: 3, label: "Moderate control" },
      { value: 4, label: "Good management" },
      { value: 5, label: "Master of my emotions" }
    ]
  },
  {
    id: 13,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How satisfied are you with your relationships (family, friends, colleagues)?",
    options: [
      { value: 1, label: "Very dissatisfied" },
      { value: 2, label: "Dissatisfied" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Satisfied" },
      { value: 5, label: "Deeply fulfilled" }
    ]
  },
  {
    id: 14,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How much inner peace do you experience in daily life?",
    options: [
      { value: 1, label: "None - Constant mental noise" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Consistent inner peace" }
    ]
  },
  {
    id: 15,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "Do you practice any form of meditation or mindfulness?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Tried but stopped" },
      { value: 3, label: "Occasionally" },
      { value: 4, label: "Regular practice" },
      { value: 5, label: "Daily - Core of my life" }
    ]
  },
  // Vijnanamaya Kosha - Wisdom Layer (5 questions)
  {
    id: 16,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "How clear are you about your life's purpose or dharma?",
    options: [
      { value: 1, label: "No clarity at all" },
      { value: 2, label: "Confused" },
      { value: 3, label: "Somewhat clear" },
      { value: 4, label: "Clear direction" },
      { value: 5, label: "Crystal clear - Living my purpose" }
    ]
  },
  {
    id: 17,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "How committed are you to personal growth and learning?",
    options: [
      { value: 1, label: "Not at all" },
      { value: 2, label: "Minimal interest" },
      { value: 3, label: "Moderate" },
      { value: 4, label: "Very committed" },
      { value: 5, label: "Lifelong learner - Always growing" }
    ]
  },
  {
    id: 18,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "How well do you trust your intuition and inner guidance?",
    options: [
      { value: 1, label: "Not at all - Ignore it" },
      { value: 2, label: "Rarely trust" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often trust" },
      { value: 5, label: "Fully guided by it" }
    ]
  },
  {
    id: 19,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "How aligned is your work with your values and talents?",
    options: [
      { value: 1, label: "Completely misaligned" },
      { value: 2, label: "Mostly misaligned" },
      { value: 3, label: "Partial alignment" },
      { value: 4, label: "Mostly aligned" },
      { value: 5, label: "Perfect alignment" }
    ]
  },
  {
    id: 20,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "Do you engage with spiritual texts, teachings, or wisdom traditions?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Occasionally" },
      { value: 4, label: "Regularly" },
      { value: 5, label: "Daily study and practice" }
    ]
  },
  // Anandamaya Kosha - Bliss Layer (5 questions)
  {
    id: 21,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "How often do you experience genuine joy and gratitude?",
    options: [
      { value: 1, label: "Rarely or never" },
      { value: 2, label: "Occasionally" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Daily - Natural state" }
    ]
  },
  {
    id: 22,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "Do you feel connected to something greater than yourself?",
    options: [
      { value: 1, label: "Not at all" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Constantly connected" }
    ]
  },
  {
    id: 23,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "How fulfilled do you feel in your life overall?",
    options: [
      { value: 1, label: "Empty - Searching for meaning" },
      { value: 2, label: "Unfulfilled" },
      { value: 3, label: "Partially fulfilled" },
      { value: 4, label: "Mostly fulfilled" },
      { value: 5, label: "Deeply fulfilled - Living my best life" }
    ]
  },
  {
    id: 24,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "Do you experience moments of transcendence or spiritual insight?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Very rarely" },
      { value: 3, label: "Occasionally" },
      { value: 4, label: "Regularly" },
      { value: 5, label: "Frequently - My spiritual life is rich" }
    ]
  },
  {
    id: 25,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "How much inner peace do you carry regardless of external circumstances?",
    options: [
      { value: 1, label: "None - Dependent on external" },
      { value: 2, label: "Very little" },
      { value: 3, label: "Some" },
      { value: 4, label: "Significant" },
      { value: 5, label: "Unshakeable peace" }
    ]
  }
];

export const calculateLifeResults = (answers) => {
  const koshaScores = {
    annamaya: [],
    pranamaya: [],
    manomaya: [],
    vijnanamaya: [],
    anandamaya: []
  };

  lifeQuestions.forEach(q => {
    if (answers[q.id]) {
      koshaScores[q.kosha].push(answers[q.id]);
    }
  });

  const calculatePercentage = (scores) => {
    if (scores.length === 0) return 0;
    const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
    return Math.round((avg / 5) * 100);
  };

  const annamaya = calculatePercentage(koshaScores.annamaya);
  const pranamaya = calculatePercentage(koshaScores.pranamaya);
  const manomaya = calculatePercentage(koshaScores.manomaya);
  const vijnanamaya = calculatePercentage(koshaScores.vijnanamaya);
  const anandamaya = calculatePercentage(koshaScores.anandamaya);

  const overall = Math.round((annamaya + pranamaya + manomaya + vijnanamaya + anandamaya) / 5);

  return { annamaya, pranamaya, manomaya, vijnanamaya, anandamaya, overall };
};

export const getLifeInsight = (kosha, score) => {
  const insights = {
    annamaya: {
      high: {
        message: "Your physical foundation is strong! You honor your body as the temple it is.",
        quote: "As the Gita says: 'Yoga is perfect evenness of mind.' Your body supports this balance."
      },
      low: {
        message: "Your physical layer needs attention. Start with sleep, nutrition, and gentle movement.",
        quote: "The body is the vehicle for the soul. Tend to it with care and awareness."
      }
    },
    pranamaya: {
      high: {
        message: "Your vital energy flows beautifully! You've cultivated a vibrant life force.",
        quote: "Prana is the bridge between body and mind. You've built a strong bridge."
      },
      low: {
        message: "Your energy reserves need replenishing. Consider breathwork and nature connection.",
        quote: "The Gita teaches: 'When prana is steady, the mind becomes steady.' Restore your vitality."
      }
    },
    manomaya: {
      high: {
        message: "Your mental and emotional balance is admirable! Inner peace is your companion.",
        quote: "You embody the Gita's teaching: 'The serene being has no disturbance.'"
      },
      low: {
        message: "Your mind seeks peace. Meditation and self-compassion are your medicine.",
        quote: "Krishna says: 'The mind can be the friend or enemy.' Make it your ally through practice."
      }
    },
    vijnanamaya: {
      high: {
        message: "Your wisdom layer shines! You're aligned with purpose and growing constantly.",
        quote: "You live the Gita's wisdom: 'Knowledge is the supreme purifier.'"
      },
      low: {
        message: "Your wisdom layer awaits cultivation. Seek teachings, reflect deeply, trust intuition.",
        quote: "The Gita reminds: 'In the darkness of night, the wise are awake.' Awaken your discernment."
      }
    },
    anandamaya: {
      high: {
        message: "Your bliss layer radiates! You've touched the divine joy within.",
        quote: "You've found what the Gita promises: 'The yogi finds infinite bliss within.'"
      },
      low: {
        message: "The bliss layer calls you. Gratitude, devotion, and surrender open this door.",
        quote: "As Krishna teaches: 'Those who worship Me with devotion, they are in Me and I am in them.'"
      }
    }
  };

  const isStrength = score >= 70;
  return {
    type: isStrength ? 'strength' : 'opportunity',
    message: insights[kosha][isStrength ? 'high' : 'low'].message,
    quote: insights[kosha][isStrength ? 'high' : 'low'].quote
  };
};
